import { render, staticRenderFns } from "./LeadsByTypeChart.vue?vue&type=template&id=70d33aec&"
import script from "./LeadsByTypeChart.vue?vue&type=script&lang=js&"
export * from "./LeadsByTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports